import { Skeleton } from '@mint-lib/tw-components';

export const LoadingCell = () => {
  return (
    <div className="flex h-full w-full items-center">
      <Skeleton variant="rounded" className="h-4 w-full" />
    </div>
  );
};
